import Store from "../../../store/index";
import * as api from "@/api/api.js";
let callback = null;
const info = new window.Browser();

const getAndroidToken = async function(token) {
  await Store.dispatch("SetAndroidToken", `JWT ${token}`);
};
const getAndroidUserId = async function(userId) {
  await Store.dispatch("SetUserId", userId);
  callback();
};
const getCommonParams = async function(data) {
  console.log(data, "getCommonParams");

  try {
    const parsed = typeof data === "string" ? JSON.parse(data) : data || {};
    const trafficTag = parsed["traffic-tag"] || parsed.trafficTag || "";
    if (trafficTag) {
      await Store.dispatch("SetTrafficTag", trafficTag);
    }
    if (parsed.app_version) {
      await Store.dispatch("SetAppVersion", parsed.app_version);
    }
    if (parsed.client_source) {
      await Store.dispatch("SetClientSource", parsed.client_source);
    }
  } catch (e) {
    // noop
  }
};

const setLocalDevParams = async cb => {
  const token = process.env.VUE_APP_LOCAL_TOKEN;
  const userId = process.env.VUE_APP_LOCAL_USER_ID;
  const trafficTag = process.env.VUE_APP_LOCAL_TRAFFIC_TAG;
  const appVersion = process.env.VUE_APP_LOCAL_APP_VERSION;
  const clientSource = process.env.VUE_APP_LOCAL_CLIENT_SOURCE;

  if (token) {
    const normalizedToken = /^jwt\s/i.test(token) ? token : `JWT ${token}`;
    localStorage.setItem("token", normalizedToken);
    await Store.dispatch("SetAndroidToken", normalizedToken);
  }
  if (userId) {
    await Store.dispatch("SetUserId", userId);
  }
  if (trafficTag) {
    await Store.dispatch("SetTrafficTag", trafficTag);
  }
  if (appVersion) {
    await Store.dispatch("SetAppVersion", appVersion);
  }
  if (clientSource) {
    await Store.dispatch("SetClientSource", clientSource);
  }
  cb();
};

export const loadToken = cb => {
  if (process.env.NODE_ENV === "development") {
    setLocalDevParams(cb);
    return;
  }

  if (window.navigator.userAgent == "Ios_WebView2020_kredi360") {
    window.webkit.messageHandlers.callIosFun.postMessage({
      name: "getIosData",
      val: ""
    });
    window["getIosData"] = async data => {
      console.log(data, "data");

      const {
        token,
        userId,
        trafficTag,
        app_version,
        client_source
      } = JSON.parse(data);
      await Store.dispatch("SetAndroidToken", `JWT ${token}`);
      await Store.dispatch("SetUserId", userId);
      await Store.dispatch("SetTrafficTag", trafficTag);
      if (app_version) {
        await Store.dispatch("SetAppVersion", app_version);
      }
      if (client_source) {
        await Store.dispatch("SetClientSource", client_source);
      }
      cb();
    };
  } else {
    if (
      window.android &&
      typeof window.android.getCommonParams === "function"
    ) {
      window.android.getCommonParams("getCommonParams");
      window["getCommonParams"] = getCommonParams;
    }
    window.android.getToken("getAndroidToken");
    window["getAndroidToken"] = getAndroidToken;
    window.android.getUserID("getAndroidUserId");
    window["getAndroidUserId"] = getAndroidUserId;
    callback = cb;
  }
};
export const reportBaseInfo = async (event, data) => {
  try {
    let token = localStorage.token
      ? localStorage.token
      : Store.state.androidToken;
    await api.reportPoint({
      applyName: "360Kredi_H5",
      createdTime: Date.now(),
      dataMap: {
        ua: navigator.userAgent,
        language: info.language,
        ...data
      },
      deviceType: info.os == "Android" ? 2 : 1,
      eventId: event,
      eventTime: Date.now(),
      osVersion: info.osVersion,
      userId: Store.state.userId || "",
      token
    });
  } catch (error) {
    // noop
  }
};
